import { type PersistStorage, type StorageValue, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';
import AppEnvironment from '../../components/enums/appEnvironment.enum';
import storage from '../../hooks/useStorage/useStorage';
import { StorageEnum } from '../../modules/context/storage';
import { AppEnvironmentStore } from './appEnvironment.store.types';

type PersistedState = Pick<AppEnvironmentStore, 'appEnvironment'>;

const customStorage: PersistStorage<PersistedState> = {
  getItem: (_name): StorageValue<PersistedState> | null => {
    const appEnvironment = storage.getItem<AppEnvironment>(StorageEnum.APP_ENVIRONMENT);
    if (!appEnvironment) {
      return null;
    }
    return { state: { appEnvironment }, version: 0 };
  },

  setItem: (_name, value: StorageValue<PersistedState>) => {
    const user = storage.getUser();
    if (!Object.keys(user).length) {
      return;
    }
    storage.setItem(StorageEnum.APP_ENVIRONMENT, value.state.appEnvironment);
  },

  removeItem: (_name) => {
    storage.removeItem(StorageEnum.APP_ENVIRONMENT);
  },
};

export const useAppEnvironmentStore = createWithEqualityFn<AppEnvironmentStore>()(
  persist(
    (set, get) => ({
      appEnvironment: undefined,

      resetAppEnvironment: () => {
        set({ appEnvironment: undefined });
      },

      handleChangeAppEnvironment: (appEnvironment) => {
        const { appEnvironment: currentAppEnvironment } = get();
        if (currentAppEnvironment !== appEnvironment) {
          set({ appEnvironment });
        }
      },
    }),
    {
      name: 'app-environment',
      storage: customStorage,
      partialize: (state) => ({ appEnvironment: state.appEnvironment }),
    },
  ),
);
